import './styles/design-tokens.css';
import './styles/globals.css';
import './version'; // Attach build signature early for production diagnostics

if (typeof document !== 'undefined') {
  const root = document.documentElement;
  if (!root.classList.contains('mode-light') && !root.classList.contains('mode-dark')) {
    root.classList.add('mode-light');
  }
}

// Dynamic import to ensure Module Federation runtime is initialized first
import("./bootstrap").catch(err => {
  // eslint-disable-next-line no-console
  console.error("Failed to load bootstrap:", err);
  // Don't throw - just log the error
});
